module.exports = __webpack_public_path__ + "img/pastures_grey_al.cf51d0e6.svg";